module.exports = __webpack_public_path__ + "af5742d7203a9b33beee76207be87f25.pdf";